import { render, staticRenderFns } from "./AccessListView.vue?vue&type=template&id=c6c9557c&scoped=true"
import script from "./AccessListView.vue?vue&type=script&lang=js"
export * from "./AccessListView.vue?vue&type=script&lang=js"
import style0 from "./AccessListView.vue?vue&type=style&index=0&id=c6c9557c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c9557c",
  null
  
)

export default component.exports